import React from 'react';
import { WrapperItem } from '../components/wrapper-item';
import { SectionItemGridHorizontal } from './section-item-grid/section-item-grid-horizontal';
import { SectionItemGridVertical } from './section-item-grid/section-item-grid-vertical';
export function SectionItemGrid(props) {
    const { section } = props;
    const layout = section.layout || 'vertical';
    return (React.createElement(WrapperItem, null,
        layout === 'vertical' && React.createElement(SectionItemGridVertical, { ...props }),
        layout === 'horizontal' && React.createElement(SectionItemGridHorizontal, { ...props })));
}
//# sourceMappingURL=section-item-grid.js.map